<template lang="html">
    <or-modal
        ref="modal"
        dismiss-on="close-button"
        :dismissible="!isRemoving"
        :title="removeModelTitle"
    >
        <p class="info-text">
            {{ $t('model.nlu-model.prebuilt-models.prebuilt-model-card.allEntitiesPhrases') }}
        </p>
        <div slot="footer">
            <or-button
                size="normal"
                color="red"
                :loading="isRemoving"
                @click.prevent="$emit('prebuilt-model::remove')"
            >
                {{ $t('generic.remove') }}
            </or-button>
            <or-button
                class="keep-it-btn"
                size="normal"
                type="secondary"
                color="primary"
                :disabled="isRemoving"
                @click="$refs.modal.close()"
            >
                {{ $t('model.nlu-model.prebuilt-models.prebuilt-model-card.keepIt') }}
            </or-button>
        </div>
    </or-modal>
</template>

<script>
export default {
  props: {
    isRemoving: {
      type: Boolean,
      default: false
    },
    removeModelTitle: String
  }
}
</script>

<style lang="scss" scoped>
.info-text {
    line-height: 21px;
}
.ui-button.keep-it-btn {
    margin-left: 16px;
}
</style>
